import { render, staticRenderFns } from "./FAQWithBorder.vue?vue&type=template&id=3035fb56&scoped=true"
import script from "./FAQWithBorder.vue?vue&type=script&lang=js"
export * from "./FAQWithBorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3035fb56",
  null
  
)

export default component.exports